import { apiService } from "../ApiService";
import GameStream, { GameStreamProtocol } from "../../model/GameStream";

export interface LaunchStreamOpts {
  os?: string;
  playerId?: string;
  playerVersion?: string;
  bearer?: string;
  protocol?: GameStreamProtocol;
  gameParameters?: string[];
  keyboardLayout?: string;
  audid?: string;
  decoderperf?: unknown;
  geoloc?: Record<"lat" | "long", number>;
}
export const launchStream = (gameId: string, opts?: LaunchStreamOpts) => {
  const {
    os = "unknown",
    bearer = "unknown",
    protocol = "webrtc",
    playerId,
    playerVersion,
    gameParameters,
    keyboardLayout,
    audid,
    decoderperf,
    geoloc,
  } = opts || {};
  return apiService.post<GameStream>({
    path: `v1/games/${gameId}/start`,
    requiresAuthPolicy: "user",
    body: {
      client: {
        id: playerId || apiService.userAgent.flavor || "js-sdk",
        version: playerVersion || apiService.userAgent.clientVersion,
        os,
        bearer,
        protocol,
        clientLatitude: geoloc?.lat,
        clientLongitude: geoloc?.long,
      },
      gameParameters,
      keyboardLayout,
      audid,
      decoderperf,
    },
  });
};
